import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fillRule="evenodd" d="M20 12.274a.75.75 0 01-.75.75h-15a.75.75 0 010-1.5h15a.75.75 0 01.75.75" clipRule="evenodd" /><path fillRule="evenodd" d="M10.831 5.72a.75.75 0 01-.002 1.061l-5.516 5.494 5.516 5.492a.75.75 0 01-1.058 1.063l-6.05-6.024a.75.75 0 010-1.063l6.05-6.025a.75.75 0 011.06.003z" clipRule="evenodd" /></svg>;